import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ManufacturingOrder,
  STOCK_VALUE,
} from '../../../../core/models/manufacturing-order';
import { getCurrentMillis, getMoment } from '../../../../core/utils/date.utils';
import { formChanged } from '../../../../core/validators/form-changed.validator';
import { AbstractEditionModalForm } from '../edition-modal/abstract-edition-modal-form';

@Component({
  selector: 'app-edit-material-form',
  templateUrl: 'edit-material-form.component.html',
  styleUrls: ['edit-material-form.component.css'],
  providers: [
    {
      provide: AbstractEditionModalForm,
      useExisting: forwardRef(() => EditMaterialFormComponent),
    },
  ],
})
export class EditMaterialFormComponent extends AbstractEditionModalForm<ManufacturingOrder> implements OnInit, OnChanges, AfterViewChecked {
  @Input() manufacturingOrderToEdit: ManufacturingOrder;
  form: FormGroup;
  hasMaterialOk: boolean;
  hasMaterialStock: boolean;
  hasMaterialWithAcutalDeliveryDate: boolean;
  hasSpecialTool: boolean;

  constructor(
    private fb: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('manufacturingOrderToEdit')) {
      this.updateForm();
    }
  }

  getMaterialStyle() {
    const formDate = this.form.get('date').value;
    const material = this.form.get('material').value;
    this.hasMaterialOk = false;
    this.hasMaterialStock = false;
    this.hasMaterialWithAcutalDeliveryDate = false;
    if (material && material !== '' && !material.toUpperCase().includes(STOCK_VALUE)) {
      this.hasMaterialOk = true;
    } else if (
      material &&
      material !== '' &&
      material.toUpperCase().includes(STOCK_VALUE)
    ) {
      this.hasMaterialStock = true;
    } else if (getMoment(formDate).valueOf() > getCurrentMillis()) {
      this.hasMaterialWithAcutalDeliveryDate = true;
    }
  }

  createForm() {
    this.form = this.fb.group({
      material: ['', [Validators.maxLength(20)]],
      hash: '',
      materialHash: '',
      date: '',
    });
    this.updateForm();
  }

  updateForm() {
    if (this.manufacturingOrderToEdit) {
      this.hasSpecialTool = this.manufacturingOrderToEdit.articleVersion.article.hasSpecialTool;
      this.hasMaterialOk = this.manufacturingOrderToEdit.hasMaterialOk;
      this.hasMaterialStock = this.manufacturingOrderToEdit.hasMaterialInStock;
      this.hasMaterialWithAcutalDeliveryDate =
        this.manufacturingOrderToEdit.hasMaterialWithAcutalDeliveryDate;
    }

    const value = {
      material: this.manufacturingOrderToEdit
        ? this.manufacturingOrderToEdit.mpReady
        : '',
      hash: this.manufacturingOrderToEdit
        ? this.manufacturingOrderToEdit.hash
        : null,
      materialHash:
        this.manufacturingOrderToEdit && this.manufacturingOrderToEdit.material
          ? this.manufacturingOrderToEdit.material.hash
          : null,
      date:
        this.manufacturingOrderToEdit &&
        this.manufacturingOrderToEdit.material &&
        this.manufacturingOrderToEdit.material.deliveryDate
          ? getMoment(this.manufacturingOrderToEdit.material.deliveryDate)
          : null,
    };
    this.resetForm(value);
  }

  private resetForm(value) {
    if (this.form) {
      this.form.setValidators(formChanged(value));
      this.form.reset(value);
    }
  }

  getFormData() {
    const value = this.form.value;
    return {
      hash: value.hash,
      material: value.material,
      materialHash: value.materialHash,
      date: getMoment(value.date).valueOf(),
    };
  }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/edit-material-form/edit-material-form.component.ts